/*
 * <prefab-tabs>
 *   <div class="tabs-nav">
 *     <nav aria-label="Tabs">
 *       <button
 *        type="button"
 *        class="tab-btn"
 *        data-tab-button="[tab_id]"
 *        aria-selected="true"
 *        aria-controls="tab-panel-[tab_id]"
 *       >
 *        Tab 1
 *       </button>
 *       …
 *     </nav>
 *   </div>
 *   <div class="tabs-content">
 *     <div
 *       id="tab-panel-[tab_id]"
 *       class="tab-panel"
 *       data-tab-panel="[tab_id]"
 *       data-tab-label="[tab_label]" <!-- overrides button text -->
 *       role="tabpanel"
 *     >
 *       <div class="tab-content">[tab_content]</div>
 *   </div>
 *   …
 * </prefab-tabs>
 */
class PrefabTabs extends HTMLElement {
  connectedCallback() {
    const buttons = this.querySelectorAll("[data-tab-button]");
    const panels = this.querySelectorAll("[data-tab-panel]");

    // Show first panel, hide the rest
    panels.forEach((panel, index) => {
      panel.classList.toggle("hidden", index !== 0);
      // Set the tab button label when data-tab-label is available
      if (buttons[index] && panel.dataset.tabLabel) {
        buttons[index].innerText = panel.dataset.tabLabel;
      }
    });

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const tabId = button.dataset.tabButton;

        // Update buttons
        buttons.forEach((btn) => {
          btn.setAttribute("aria-selected", btn.dataset.tabButton === tabId);
        });

        // Update panels
        panels.forEach((panel) => {
          panel.classList.toggle("hidden", panel.dataset.tabPanel !== tabId);
        });
      });
    });
  }
}

customElements.define("prefab-tabs", PrefabTabs);
